export const multiViewData = {
    contactInvoiceEditMV: {
        viewKind: 'card',
        view: 'contactInvoiceCard',
        sidePanel: 'invoiceEditPanel',
        width: '1800px',
        mainWidth: '1236px',
        wideScreen: 'panel',
    },
    creditNoteEditMV: {
        viewKind: 'card',
        view: 'creditNoteCard',
        sidePanel: 'invoiceViewPanel',
        width: '1800px',
        mainWidth: '1236px',
        wideScreen: 'panel',
    },
    creditNoteViewMV: {
        viewKind: 'display',
        view: 'creditNoteDisplayView',
        sidePanel: 'creditNoteViewPanel',
        width: '1500px',
        mainWidth: '936px',
        wideScreen: 'panel',
    },
    docBrowserMV: {
        viewKind: 'FolderTree',
        sidePanel: 'documentList',
        width: '1300px'
    },
    documentFileMV: {
        viewKind: 'card',
        view: 'documentCard',
        sidePanel: 'documentFilePanel',
        width: '1300px',
    },
    documentRichTextMV: {
        viewKind: 'card',
        view: 'documentRichTextCard',
        sidePanel: 'documentRichTextPanel',
        width: '1300px',
    },
    /*
     * The documents sit on the left and take a wide screen's spare. A draft —
     * new, from a purchase order, from the Inbox — is read off its receipt,
     * with the suggestion above it in the same panel, so the receipt gets its
     * full 900px beside the 1024px card; a booked one stops at 1500px, as the
     * other booked documents.
     */
    expenseEditMV: {
        viewKind: 'card',
        view: 'expenseCard',
        sidePanel: 'expensePanel',
        width: '2000px',
        mainWidth: '1060px',
        wideScreen: 'panel',
    },
    expenseViewMV: {
        viewKind: 'display',
        view: 'expenseDisplayView',
        sidePanel: 'expensePanel',
        width: '1500px',
        mainWidth: '936px',
        wideScreen: 'panel',
    },
    fastJournalEditMV: {
        viewKind: 'card',
        view: 'fastJournalCard',
        sidePanel: 'journalPanel',
        width: '2600px',
        // As the journal card: the grid keeps its 1600px card (with its
        // padding), the documents take a wide screen's spare up to their 900px,
        // and past that the page sits in the middle. On a screen too narrow
        // for both, the grid gives way rather than squeeze the documents.
        mainWidth: '1630px',
        wideScreen: 'panel',
    },
    /*
     * As the journals: the invoice keeps its width and a wide screen goes to
     * the PDF beside it, up to 1800px in all (1500px booked). mainWidth is the widest
     * section plus the view's padding — the card's are 1200px, the display's
     * 900px — so neither leaves a gap before the PDF.
     */
    invoiceEditMV: {
        viewKind: 'card',
        view: 'invoiceCard',
        sidePanel: 'invoiceEditPanel',
        width: '1800px',
        mainWidth: '1236px',
        wideScreen: 'panel',
    },
    invoiceViewMV: {
        viewKind: 'display',
        view: 'invoiceDisplayView',
        sidePanel: 'invoiceViewPanel',
        width: '1500px',
        mainWidth: '936px',
        wideScreen: 'panel',
    },
    /*
     * The card is 1024px wide whatever the screen, so a wide screen goes to
     * the documents beside it — a receipt reads better larger — up to 2000px:
     * the card, the panel at its 900px most, and the handle between. Past that
     * the page sits in the middle.
     */
    journalEditMV: {
        viewKind: 'card',
        view: 'journalCard',
        sidePanel: 'journalPanel',
        width: '2000px',
        mainWidth: '1060px',
        wideScreen: 'panel',
    },
    journalViewMV: {
        viewKind: 'display',
        view: 'journalDisplayView',
        sidePanel: 'journalPanel',
        width: '2000px',
        mainWidth: '1060px',
        wideScreen: 'panel',
    },
    portalInvoiceViewMV: {
        viewKind: 'display',
        view: 'portalInvoiceDisplayView',
        sidePanel: 'invoiceViewPanel',
        width: '1500px',
        mainWidth: '936px',
        wideScreen: 'panel',
    },
    purchaseOrderEditMV: {
        viewKind: 'card',
        view: 'purchaseOrderCard',
        sidePanel: 'purchaseOrderEditPanel',
        width: '1800px',
        mainWidth: '1236px',
        wideScreen: 'panel',
    },
    purchaseOrderViewMV: {
        viewKind: 'display',
        view: 'purchaseOrderDisplayView',
        sidePanel: 'purchaseOrderViewPanel',
        width: '1500px',
        mainWidth: '936px',
        wideScreen: 'panel',
    },
    purchaseRequestDraftMV: {
        viewKind: 'card',
        view: 'purchaseRequestDraftCard',
        width: '1300px',
    },
    purchaseRequestSubmittedMV: {
        viewKind: 'card',
        view: 'purchaseRequestSubmittedCard',
        width: '1300px',
    },
    quoteEditMV: {
        viewKind: 'card',
        view: 'quoteCard',
        sidePanel: 'quoteEditPanel',
        width: '1800px',
        mainWidth: '1236px',
        wideScreen: 'panel',
    },
    quoteViewMV: {
        viewKind: 'display',
        view: 'quoteDisplayView',
        sidePanel: 'quoteViewPanel',
        width: '1500px',
        mainWidth: '936px',
        wideScreen: 'panel',
    },
    stockReceiptEditMV: {
        viewKind: 'card',
        view: 'stockReceiptCard',
        sidePanel: 'stockReceiptEditPanel',
        width: '1800px',
        mainWidth: '1236px',
        wideScreen: 'panel',
    },
    stockReceiptViewMV: {
        viewKind: 'display',
        view: 'stockReceiptDisplayView',
        sidePanel: 'stockReceiptViewPanel',
        width: '1500px',
        mainWidth: '936px',
        wideScreen: 'panel',
    },
    stockShipmentEditMV: {
        viewKind: 'card',
        view: 'stockShipmentCard',
        sidePanel: 'stockShipmentEditPanel',
        width: '1800px',
        mainWidth: '1236px',
        wideScreen: 'panel',
    },
    stockShipmentViewMV: {
        viewKind: 'display',
        view: 'stockShipmentDisplayView',
        sidePanel: 'stockShipmentViewPanel',
        width: '1500px',
        mainWidth: '936px',
        wideScreen: 'panel',
    },
    warehouseOrderEditMV: {
        viewKind: 'card',
        view: 'warehouseOrderCard',
        width: '1200px',
    },
    warehouseOrderViewMV: {
        viewKind: 'display',
        view: 'warehouseOrderDisplayView',
        width: '1200px',
    },
}